/*

    Component to display the sub categories of the Category

*/
import React , { Component } from "react";
import { Dropdown, DropdownToggle, DropdownMenu, DropdownItem } from "reactstrap";


import { ThemeContext } from "corp-site/employer/context/ThemeContext";


class VerticalSubCatDisplay extends Component {
    constructor(props){
        super( props );
        this.state = {
            isOpen : false
        }
    }

    onToggle = () => {
        this.setState({
            isOpen : !this.state.isOpen
        });
    }

    onSubCatPick( event, item ) {
        if( this.props.handleSubCat ){
            this.props.handleSubCat( item );
        }
        event.preventDefault();
    }

    render(){
        return (
            <div className={"text-center vertical_subcat_display " + ( this.context ? " vertical_subcat_display_"+this.context : "")}>
                <ul>
                    <li className={ this.props.active === "" ? "active" : ""}><a href="" onClick={(event)=>this.onSubCatPick( event, "" )} >All {this.props.vertical}</a></li>
                    {this.props.subCategories.slice(0,this.props.subCatCount || this.props.subCategories.length ).map((item,index) => (
                        <li className={ "d-none d-md-inline-block " + (this.props.active === item ? "active" : "") } key={index}><a href="" onClick={(event)=>this.onSubCatPick( event, item )} >{item}</a></li>
                    ))}
                    <li className={ this.props.subCategories.length <= this.props.subCatCount ? " d-md-none " : "" } >
                        <Dropdown isOpen={this.state.isOpen} toggle={this.onToggle} >
                            <DropdownToggle caret tag="a" className="text-light" ></DropdownToggle>
                            <DropdownMenu right >
                                { this.props.subCategories.length > this.props.subCatCount && this.props.subCategories.slice(this.props.subCatCount).map((item,index)=>(
                                    <DropdownItem className="d-none d-md-block" active={ this.props.active === item } onClick={(event)=>this.onSubCatPick( event, item )} key={index} tag="a">{item}</DropdownItem>
                                ))}
                                { this.props.subCategories.map((item,index)=>(
                                    <DropdownItem className="d-md-none" active={ this.props.active === item } onClick={(event)=>this.onSubCatPick( event, item )} key={index} tag="a">{item}</DropdownItem>
                                ))}
                            </DropdownMenu>
                        </Dropdown>
                    </li>
                </ul>
            </div>
        )
    }
}

VerticalSubCatDisplay.contextType = ThemeContext;

export default VerticalSubCatDisplay;